import { configure } from 'vee-validate';

// Define nice, human-readable field names
export const fieldNames = {
  firstName: 'First Name',
  lastName: 'Last Name',
  email: 'Email Address',
  password: 'Password',
  confirmPassword: 'Confirm Password',
  phoneNumber: 'Phone Number',
  address1: 'Address',
  address2: 'Address Line 2',
  city: 'City',
  state: 'State',
  zipCode: 'Zip Code',
  districtId: 'School District'
};

// Configure VeeValidate to use these field names
export function configureFieldNames() {
  configure({
    generateMessage: ({ field, rule }) => {
      const fieldName = fieldNames[field] || field.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
      
      return `${fieldName} is required`;
    }
  });
}

// Apply field name formatting to your validation errors even without VeeValidate
export function formatErrorMessages(errors) {
  if (!errors || !errors.length) return [];
  
  return errors.map(error => {
    // Check if the error follows a pattern like "fieldName is required"
    const fieldMatch = error.match(/^([a-zA-Z0-9]+)(\s+is\s+.*)/);
    if (fieldMatch) {
      const fieldName = fieldMatch[1];
      const errorPart = fieldMatch[2];
      
      // Use our field name mapping or apply basic formatting
      const prettyFieldName = fieldNames[fieldName] || 
                            fieldName.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
                            
      return prettyFieldName + errorPart;
    }
    
    return error; // Return the original error if it doesn't match the pattern
  });
}
